import React from 'react';
import InvitationModal from './InvitationModal';
import InsufficientTokensModal from './InsufficientTokensModal';

/**
 * Component that renders global modals that can be triggered from anywhere in the app
 */
const GlobalModals: React.FC = () => {
  return (
    <>
      <InvitationModal />
      <InsufficientTokensModal />
    </>
  );
};

export default GlobalModals;
